import { render } from "./UserInfoView.vue?vue&type=template&id=67f49ba5&scoped=true"
import script from "./UserInfoView.vue?vue&type=script&lang=js"
export * from "./UserInfoView.vue?vue&type=script&lang=js"

import "./UserInfoView.vue?vue&type=style&index=0&id=67f49ba5&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f49ba5"]])

export default __exports__